import { Controller } from "@hotwired/stimulus";

const HIGHLIGHT_CLASSES = ["!bg-yellow-100"];

// Jumps from a structure table search hit to its row: scrolls to and highlights the row, or first
// visits the table page it is on. The row's anchor carries the jump across the visit.
export default class extends Controller {
  connect() {
    const rankId = window.location.hash.match(/^#agent-rank-(\d+)-tr$/)?.[1];
    if (rankId) this.reveal(rankId);
  }

  disconnect() {
    clearTimeout(this.highlightTimeout);
  }

  jump(event) {
    const { rankId, page } = event.params;
    if (this.reveal(rankId)) return;

    const url = new URL(window.location.href);
    url.searchParams.set("page", page);
    url.hash = `agent-rank-${rankId}-tr`;
    Turbo.visit(url.toString());
  }

  reveal(rankId) {
    const row = this.element.querySelector(`#agent-rank-${CSS.escape(String(rankId))}-tr`);
    if (!row) return false;

    row.scrollIntoView({ behavior: "smooth", block: "center" });
    this.highlight(row);
    return true;
  }

  highlight(row) {
    clearTimeout(this.highlightTimeout);
    this.highlightedRow?.classList.remove(...HIGHLIGHT_CLASSES);

    row.classList.add(...HIGHLIGHT_CLASSES);
    this.highlightedRow = row;
    this.highlightTimeout = setTimeout(() => {
      row.classList.remove(...HIGHLIGHT_CLASSES);
      this.highlightedRow = null;
    }, 1800);
  }
}
